/**
 * patrol.js
 */

import React from 'react';
import { useWatch } from 'react-hook-form';
import { Types } from 'utils/constants';
import HiddenInput from 'components/form-inputs/hidden-input';
import PatrolObedienceEdit from './patrol-obedience-edit';
import PatrolAgilityEdit from './patrol-agility-edit';
import PatrolApprehensionEdit from './patrol-apprehension-edit';
import PatrolHumanSearchEdit from './patrol-human-search-edit';
import PatrolEvidenceSearchEdit from './patrol-evidence-search-edit';
import PatrolBuildingSearchEdit from './patrol-building-search-edit';
import PatrolTrackingEdit from './patrol-tracking-edit';
import PatrolOtherEdit from './patrol-other-edit';


export default function AnswerEditPatrol(props) {
  const {
    storedRecord,
    control,
    formPrefix = '',
  } = props;
  const wasPerformedValue = useWatch({ control, name: `${formPrefix}wasExercisePerformed` });
  

  const getPatrolTypeEditor = (patrolRecord, index) => {
    let Component = '';

    switch (patrolRecord.type) {
      case Types.Patrol.AGILITY:
        Component = PatrolAgilityEdit;
        break;

      case Types.Patrol.APPREHENSION:
        Component = PatrolApprehensionEdit;
        break;

      case Types.Patrol.BUILDING_SEARCH:
        Component = PatrolBuildingSearchEdit;
        break;

      case Types.Patrol.EVIDENCE_SEARCH:
        Component = PatrolEvidenceSearchEdit;
        break;

      case Types.Patrol.HUMAN_SEARCH:
        Component = PatrolHumanSearchEdit;
        break;

      case Types.Patrol.OBEDIENCE:
        Component = PatrolObedienceEdit;
        break;

      case Types.Patrol.TRACKING:
        Component = PatrolTrackingEdit;
        break;

      case Types.Patrol.OTHER:
        Component = PatrolOtherEdit;
        break;

      default:
        return '';
    }

    return (
      <div key={patrolRecord.id || patrolRecord.uuid}>
        <HiddenInput
          name={`${formPrefix}patrol.patrolTypes[${index}].id`}
          defaultValue={patrolRecord.id}
        />
        <HiddenInput
          name={`${formPrefix}patrol.patrolTypes[${index}].type`}
          defaultValue={patrolRecord.type}
        />
        <Component 
          patrolRecord={patrolRecord}
          patrolIndex={index}
          patrolTypes={storedRecord.patrol.patrolTypes}
          {...props} 
        />
      </div>
    );
  }


  return (
    <>
      {wasPerformedValue && storedRecord.patrol !== null &&
      <>
        {storedRecord.patrol.patrolTypes.map((patrolRecord, i) => getPatrolTypeEditor(patrolRecord, i))}
      </>}
    </>
  );
}